<template>
  <div>
    <!-- //^ ^--------------新增/编辑的对话框-------------^ ^ -->
    <el-dialog
      title="添加文件"
      :visible.sync="dialog.visible"
      append-to-body
      :modal-append-to-body="false"
      @closed="beforeClose"
      :close-on-click-modal="false"
      width="50%"
    >
      <!-- 转码分组 -->
      <div style="display: flex; justify-content: space-between">
        <div style="margin-left: 20px">
          <span>转码分组：</span>
          <!-- 选择转码分组 下拉选择 -->
          <el-select
            v-model="templateGroupValue"
            placeholder="请选择转码分组"
            size="mini"
          >
            <el-option
              v-for="item in templateGroup"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <el-upload
            action="#"
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
            multiple
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div class="el-upload__tip" slot="tip"></div>
          </el-upload>
        </div>
      </div>
      <div class="upload" v-if="fileInfoList.length === 0">
        <el-upload
          class="upload-file-select"
          drag
          action="#"
          :on-change="uploadFile"
          :show-file-list="false"
          :auto-upload="false"
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖拽到此处，或<em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip"></div>
        </el-upload>
      </div>
      <!-- 文件列表 -->
      <div class="file-container">
        <div class="file-list" v-for="item in fileInfoList" :key="item.fileId">
          <div>
            <span class="file-name">{{ item.filename }}</span>
          </div>
          <div class="file-info">
            <span>格式：{{ item.fileExt }}</span
            >&nbsp;&nbsp;&nbsp;<span
              >分辨率：{{
                item.media.videoWidth + 'x' + item.media.videoHeight
              }}</span
            >&nbsp;&nbsp;&nbsp;<span>时长：{{ item.media.videoDuration }}</span
            >&nbsp;&nbsp;&nbsp;<span>文件大小：{{ item.fileSize + 'M' }}</span>
          </div>
          <div>
            <span v-if="item.status === 'ready'"
              >等待上传<span
                class="cancel-icon"
                @click="handleCancelReady(item)"
                >×</span
              ></span
            >
            <span v-if="item.status === 'uploading'" class="file-percent"
              >上传进度：{{ item.uploadProgress + '%' }}</span
            >
            <span v-if="item.status === 'cancel'">已取消上传 </span>
            <span v-if="item.status === 'failed'" style="color: red"
              >上传失败
            </span>
            <span v-if="item.status === 'finished'" style="color: #3dcc55"
              >上传成功</span
            >
            <span
              v-if="item.status === 'uploading' && item.uploadProgress != 0"
              class="cancel-icon"
              @click="handleCancelUpload(item)"
              >×</span
            >
          </div>
        </div>
      </div>
      <!-- 保存-取消 -->
      <!-- <span slot="footer" style="flex-end">
        <el-button @click="hide">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">保 存</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import Message from '@/components/Message'
import { FileMixins } from './file-mixins'

export default {
  name: 'WebSassAdd',
  mixins: [FileMixins],
  props: {
    templateGroup: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      /** 转码分组的value */
      templateGroupValue: '',
      dialog: {
        visible: false
      }
    }
  },
  methods: {
    // ^ ^--------------对话框内的事件-------------^ ^
    /** 取消等待上传 */
    handleCancelReady(item) {
      console.log('取消等待上传', item)
      item.status = 'cancel'
    },
    /** 取消上传 */
    handleCancelUpload(item) {
      console.log('取消上传', item)
      item.vod.cancelUpload()
      item.vod.delUpload()
      item.status = 'cancel'
    },
    /** 确认的事件 */
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          /** 验证通过 */
          this.hide()
        } else {
          /** 验证失败 */
          Message.error('请检查表单')
        }
      })
    },
    show(templateGroup) {
      if (templateGroup) {
        console.log('转递过来的templateGroup', templateGroup)
        this.templateGroup = [...templateGroup]
        this.templateGroupValue = templateGroup[0].value
      }
      this.dialog.visible = true
    },
    hide() {
      this.dialog.visible = false
      /** 页面关闭 未上传成功的中断上传 */
      console.log('页面关闭 未上传成功的中断上传')
      console.log('this.fileInfoList', this.fileInfoList)
      this.fileInfoList.forEach((item) => {
        if (item.status === 'uploading') {
          item.vod.cancelUpload()
          item.vod.delUpload()
        }
      })
      /** 清理数据 */
      this.fileInfoList = []
    },
    beforeClose() {
      console.log('页面关闭 未上传成功的中断上传')
      console.log('this.fileInfoList', this.fileInfoList)
      this.fileInfoList.forEach((item) => {
        if (item.status === 'uploading') {
          item.vod.cancelUpload()
          item.vod.delUpload()
        }
      })
      /** 清理数据 */
      this.fileInfoList = []
      /** 通知需要刷新数据 */
      this.$emit('refresh')
    }
  }
}
</script>

<style lang="scss" scoped>
.file-container {
  margin-top: 20px;
  max-height: 300px;
  overflow-y: auto;
}
.file-list {
  padding: 0 20px;
  height: 50px;
  background-color: #efefef;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .file-name {
    font-weight: bold;
  }
  .file-info {
    color: #b8b8b8;
  }
  .file-percent {
    color: #5c74f4;
  }
  .cancel-icon {
    color: #b8b8b8;
    cursor: pointer;
  }
}
.upload {
  margin-top: 20px;
  /** 居中 */
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  .upload-file-select {
    width: 100%;
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-upload--text {
    width: 100% !important;
    height: 100% !important;
  }
  ::v-deep .el-upload-dragger {
    width: 100% !important;
    height: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
::v-deep .el-input__inner {
  padding-right: 50px !important;
}

::v-deep .el-textarea__inner {
  padding-right: 55px !important;
  max-height: 100px !important;
}
</style>